// @ts-ignore
import normalize from 'normalize-object';
import _ from 'lodash';

const toCamelCase = (object: any) => {
  if (typeof object === 'string') {
    return _.camelCase(object);
  }
  return normalize(object, 'camel');
};

export default toCamelCase;
